import { createReducer, on } from "@ngrx/store";

import { initialState } from "./notifications.state";
import { NotificationsActions } from "./notifications.actions";

export const notificationsReducer = createReducer(
  initialState,

  on(NotificationsActions.reset, (state) => initialState),

  on(NotificationsActions.messageOccured, (state, { message }) => {
    let newMessages = [...state.notifications ];
    newMessages.push(message);
    return { ...state, notifications: newMessages, shouldShowNotifcations: true }
  }),

  on(NotificationsActions.errorOccured, (state, { error }) => {
    let notifications = [...state.notifications];
    notifications.push(error);
    return {...state, notifications: notifications, shouldShowNotifcations: true }
  }),

  on(NotificationsActions.dismissed, (state, { id }) => {
    const i = state.notifications.findIndex(x => x.id == id);
    let notifications = [ ...state.notifications ];
    notifications.splice(i, 1);
    let shouldShow: boolean = state.shouldShowNotifcations;
    if (notifications.length === 0) { shouldShow = false; }
    return { ...state, notifications: notifications, shouldShowNotifcations: shouldShow };
  }),

  on(NotificationsActions.dismissAll, (state) => {
    return { ...state, notifications: [], shouldShowNotifcations: false }
  }),

  on(NotificationsActions.toggle, (state) => {
    return { ...state, shouldShowNotifcations: !state.shouldShowNotifcations }
  }),
);